import { SET_ENV, SET_ENV_TOKEN, SET_REFRESH, SET_ISNEW } from './constants';
import { ToggleActionTypes } from './types';
import { api } from "../../helpers/api/apiCore";

interface ToggleState {
  toggleDetails: {
    env: string;
    token: string;
    refresh: boolean;
    isNew: boolean;
    kyc_verified: boolean;
  };
}

const initialState: ToggleState = {
  toggleDetails: {
    env: localStorage.getItem("app_env") || "TEST",
    token: '',
    refresh: false,
    isNew: localStorage.getItem("is_new") === 'true',
    kyc_verified: localStorage.getItem("kyc_verified") === 'true',
  },
};

const toggleReducer = (state = initialState, action: ToggleActionTypes): ToggleState => {
  switch (action.type) {
    case SET_ENV:
      const newState = {
        ...state,
        toggleDetails: {
          ...state.toggleDetails,
          env: action.payload.env,
          refresh: true,
        },
      };
      
      api.setAppEnv(action.payload.env);

      return newState;
    case SET_REFRESH:
      return {
        ...state,
        toggleDetails: {
          ...state.toggleDetails,
          refresh: action.payload.refresh,
        },
      };

      case SET_ENV_TOKEN:
      return {
        ...state,
        toggleDetails: {
          ...state.toggleDetails,
          token: action.payload.token,
        },
      };

      case SET_ISNEW:
      return {
        ...state,
        toggleDetails: {
          ...state.toggleDetails,
          isNew: action.payload.isNew,
        },
      };
    default:
      return state;
  }
};

export default toggleReducer;
